import React from 'react';
import { FilledButton } from '../../app/components';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import NumberFormat from 'react-number-format';
import './styles.css';

const ContactStep = ({ fields, assignRef, onSelectContactInfo }) => (
  <div className="step-content contact-step">
    <h2>Hafa samband</h2>
    <p>
      Veldu þær leiðir sem þú vilt að leigjendur geti haft
      samband við þig varðandi leigu á eigninni.
    </p>
    <div className="contact-info">
      <Checkbox
        checked={fields.contactFacebook.value}
        onCheck={(e, isInputChecked) => onSelectContactInfo(isInputChecked, 'contactFacebook')}
        label={
          <FilledButton
            content={<div><span className="icon-messenger-icon" /><p>Facebook Messenger</p></div>}
            disabled={false}
            color="#ffffff"
            backgroundColor="#0084ff"
            onClick={e => e.preventDefault()}
          />
        }
        labelStyle={{ width: '100%' }}
      />
      <Checkbox
        checked={fields.contactEmail.value}
        onCheck={(e, isInputChecked) => onSelectContactInfo(isInputChecked, 'contactEmail')}
        label={
          <FilledButton
            content={<div><span className="icon-email-icon" /><p>Tölvupóstur</p></div>}
            disabled={false}
            color="#ffffff"
            backgroundColor="#222222"
            onClick={e => e.preventDefault()}
          />
        }
        labelStyle={{ width: '100%' }}
      />
      <TextField
        {...fields.contactEmailValue}
        className={`${!fields.contactEmail.value ? 'hidden-input' : ''}`}
        ref={assignRef ? c => assignRef('contactEmailValue', c) : null}
        hintText="Sláðu inn netfang"
      />
      <Checkbox
        checked={fields.contactPhonenumber.value}
        onCheck={(e, isInputChecked) => onSelectContactInfo(isInputChecked, 'contactPhonenumber')}
        label={
          <FilledButton
            content={<div><span className="icon-phone" /><p>Símanúmer</p></div>}
            disabled={false}
            color="#ffffff"
            backgroundColor="#222222"
            onClick={e => e.preventDefault()}
          />
        }
        labelStyle={{ width: '100%' }}
      />
      <TextField
        value={fields.contactPhonenumberValue.value}
        className={`${!fields.contactPhonenumber.value ? 'hidden-input' : ''}`}
        ref={assignRef ? c => assignRef('contactPhonenumberValue', c) : null}
        pattern="[0-9]*" type="number"
        hintText="Sláðu inn símanúmer"
      >
        <NumberFormat {...fields.contactPhonenumberValue} format="#######" />
      </TextField>
    </div>
  </div>
);

ContactStep.propTypes = {
  fields: React.PropTypes.object.isRequired,
  assignRef: React.PropTypes.func,
  onSelectContactInfo: React.PropTypes.func.isRequired,
};

export default ContactStep;



// WEBPACK FOOTER //
// ./src/browser/steps/ContactStep/ContactStep.js